import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import api from '@/api/agreement';

@Module({ namespaced: true })
export default class extends VuexModule {
  @Action
  async list(params: any) {
    return api.list(params);
  }

  @Action
  async add(params: any) {
    return api.add(params);
  }

  @Action
  async edit(params: any) {
    return api.edit(params);
  }

  @Action
  async detail(params: any) {
    return api.detail(params);
  }

  @Action
  async delete(params: any) {
    return api.delete(params);
  }

  @Action
  async records(params: any) {
    return api.records(params);
  }

  @Action
  async audit(params: any) {
    return api.audit(params);
  }

  @Action
  async items(params: any) {
    return api.items(params);
  }

  @Action
  async additem(params: any) {
    return api.additem(params);
  }

  @Action
  async edititem(params: any) {
    return api.edititem(params);
  }

  @Action
  async detailitem(params: any) {
    return api.detailitem(params);
  }

  @Action
  async deleteitem(params: any) {
    return api.deleteitem(params);
  }

  @Action
  async versions(params: any) {
    return api.versions(params);
  }

  @Action
  async copyNew(params: any) {
    return api.copyNew(params);
  }
}
